import { useState, useEffect } from 'react'
import Spinner from '../Spinner/Spinner'
import Page from './Page'

const Dashboard = () => {
	const [loading, setLoading] = useState(false)
	const [posts, setPosts] = useState([])
	const [contacts, setcontacts] = useState([])
	const [newsletters, setNewsLetters] = useState([])

	useEffect(() => {
		setLoading(true)
		fetch('https://cp-node-api.herokuapp.com/api/posts')
			.then((res) => res.json())
			.then((data) => [setPosts(data), setLoading(false)])
	}, [])

	useEffect(() => {
		setLoading(true)
		fetch('https://cp-node-api.herokuapp.com/api/contact')
			.then((res) => res.json())
			.then((data) => [setcontacts(data), setLoading(false)])
	}, [])

	useEffect(() => {
		setLoading(true)
		fetch('https://cp-node-api.herokuapp.com/api/newsletters')
			.then((res) => res.json())
			.then((data) => [setNewsLetters(data), setLoading(false)])
	}, [])
	return (
		<Page>
			<div className='card-wrapper'>
				{loading ? (
					<Spinner />
				) : (
					<>
						<div className='card-item'>
							<h3>Blog Post</h3>
							<span>{posts?.msg ? '0' : posts.length}</span>
						</div>
						<div className='card-item'>
							<h3>Contacts</h3>
							<span>{contacts.length}</span>
						</div>
						<div className='card-item'>
							<h3>Newsletters</h3>
							<span>{newsletters?.msg ? '0' : posts.length}</span>
						</div>
						<div className='card-item'>
							<h3>Team Members</h3>
							<span>5</span>
						</div>
					</>
				)}
			</div>
		</Page>
	)
}

export default Dashboard
